import React from 'react';
import {connect} from 'react-redux';
// Components
import Header from 'Components/common/Header';
import LoadingIcon from 'Components/icons/LoadingIcon';

// Actions
import {
    getF1ShipmentViewData,
    refreshF1OrderList,
    setF1OrderSource,
} from 'Actions/host';
import {T} from 'Actions/translate';

// Icons
import {ArrowForwardIos} from '@material-ui/icons';

class F1OrderReceiveManagement extends React.Component {
    state = {
        f1OrderReceiveManagementPageLoad: true,
    };

    componentWillMount() {
        this.getF1ShipmentViewData();
    }

    getF1ShipmentViewData = () => {
        this.setState({
            f1OrderReceiveManagementPageLoad: true,
        });
        let paramsObj = this.props.match.params;
        this.props
            .getF1ShipmentViewData(paramsObj)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        f1OrderReceiveManagementPageLoad: false,
                    });
                }
            })
            .catch((res) => {
                this.setState({
                    f1OrderReceiveManagementPageLoad: true,
                });
            });
    };

    showShipmentStatau = (status, item, index, orderStatus) => {
        return (
            <li
                key={status + '-' + index}
                onClick={() => this.f1OrderReceiveHandle(status, item)}>
                <div className="shipment-status-container">
                    <p className="shipment-status">
                        {T('host_shipment_status')}
                        <span className="shipment-status-value">
                            {status === 'toBeReceived'
                                ? T('wait_for_receiving')
                                : status === 'toBeShipped'
                                ? orderStatus === -1
                                    ? T('backup_status_RECALL')
                                    : T('to_send_the_goods')
                                : T('user_center_received')}
                        </span>
                    </p>
                    <span className="shipment-icon-area">
                        <ArrowForwardIos />
                    </span>
                </div>
                {status !== 'toBeShipped' ? (
                    <div>
                        <div className="first-row">
                            {T('host_express_number')}
                            <span className="row-value">
                                {item.shipmentNumber}
                            </span>
                        </div>
                        <div className="second-row">
                            {T('shippment_details_actual_ship_date')}
                            <span className="row-value">
                                {item.shipmentDate}
                            </span>
                        </div>
                        <div className="third-row">
                            {T('host_logistics_company')}
                            <span className="row-value">
                                {item.carrierName}
                            </span>
                        </div>
                        {status === 'received' ? (
                            <div className="third-row">
                                {T('host_fone_receive_date')}
                                <span className="row-value">
                                    {item.receivedTime}
                                </span>
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div className="first-row">
                        <div className="sku-type">
                            {T('host_sku_type_of_number')}
                            <span className="row-value">{item.skuCount}</span>
                        </div>
                        <span className="f1-tobe-shipped-quantity">
                            {T('host_tobe_shipped_quantity')}
                            <span className="order-status-value">
                                {item.quantity}
                            </span>
                        </span>
                    </div>
                )}
            </li>
        );
    };

    orderDetailHandle = () => {
        this.props.history.push(
            `/F1OrderDetailPage/${this.props.match.params.id}`,
        );
    };

    f1OrderReceiveHandle = (status, item) => {
        console.log(
            this.props.match.params.id,
            'shipmentNumber:',
            item.shipmentNumber,
            'orderStatus:',
            status,
            'id:',
            item.id,
        );
        if (status === 'toBeReceived') {
            this.props.history.push('/F1PackageReceive/', {
                id: this.props.match.params.id,
                shipmentNumber: item.shipmentNumber,
                orderStatus: status,
            });
        } else if (status === 'received') {
            this.props.history.push('/F1PackageReceive/', {
                id: this.props.match.params.id,
                shipmentNumber: item.shipmentNumber,
                orderStatus: status,
                id: item.id,
            });
        } else {
            this.props.history.push('/F1PackageReceive/', {
                id: this.props.match.params.id,
                orderStatus: status,
            });
        }
    };

    goBack = () => {
        // this.props.history.push('/F1OrderList');
        this.props.setF1OrderSource({$set: true});
        this.props.history.goBack();
    };

    handleRefresh = () => {
        this.setState({
            f1OrderReceiveManagementPageLoad: true,
        });
        this.props
            .refreshF1OrderList(this.props.match.params.id)
            .then((res) => {
                if (res.status == 'success') {
                    this.setState({
                        f1OrderReceiveManagementPageLoad: false,
                    });
                    this.getF1ShipmentViewData();
                }
            });
    };

    render() {
        const {f1ShipmentViewData} = this.props;
        const {f1OrderReceiveManagementPageLoad} = this.state;

        return (
            <div className="F1-order-receive-management-container">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="F1-order-list-header-title">
                        <p className="header-f1-receive-title">
                            {T('header_fone_shippment_management')}
                        </p>
                        <p
                            onClick={this.handleRefresh}
                            className="header_fone_refresh">
                            {T('header_fone_refresh')}
                        </p>
                    </div>
                </Header>
                {f1OrderReceiveManagementPageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <div className="f1-shipment-div">
                        {JSON.stringify(f1ShipmentViewData) !== '{}' ? (
                            <div className="f1-receive-order-header">
                                <div className="f1-order-container">
                                    <p className="header-order-number">
                                        {T('host_fone_order_number')}
                                        <span className="order-numer">
                                            {f1ShipmentViewData.number}
                                        </span>
                                    </p>
                                    <span
                                        className="view-f1-receive-detail"
                                        onClick={this.orderDetailHandle}>
                                        {T('product_more_details')}
                                        <ArrowForwardIos />
                                    </span>
                                </div>
                                <div className="f1-order-status">
                                    <div className="f1-order">
                                        {T('host_fone_e1_order_number')}
                                        <span className="f1-order-numer-value">
                                            {f1ShipmentViewData.eoneNumber}
                                        </span>
                                    </div>
                                    <span className="f1-status">
                                        {T('host_fone_order_status')}
                                        <span className="order-status-value">
                                            {T(f1ShipmentViewData.eoneStatus)}
                                        </span>
                                    </span>
                                </div>
                                <div className="f1-shipment-content">
                                    <div className="f1-shipment-time">
                                        {T('host_fone_replenishment_date')}
                                        <span className="f1-shipment-time-value">
                                            {f1ShipmentViewData.createTime}
                                        </span>
                                    </div>
                                    <span className="f1-replenishment-amount">
                                        {T('host_fone_replenishment_amount')}
                                        <span className="f1-replenishment_amount-value">
                                            {f1ShipmentViewData.totalQuantity}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        ) : null}
                        <ul className="f1-tobe-received-view-container first-ul-style">
                            {JSON.stringify(f1ShipmentViewData) !== '{}' &&
                                f1ShipmentViewData.toBeReceived &&
                                f1ShipmentViewData.toBeReceived.length > 0 &&
                                f1ShipmentViewData.toBeReceived.map(
                                    (toBeItem, toBeIndex) =>
                                        this.showShipmentStatau(
                                            'toBeReceived',
                                            toBeItem,
                                            toBeIndex,
                                            f1ShipmentViewData.status,
                                        ),
                                )}
                        </ul>
                        <ul className="f1-tobe-shipped-view-container">
                            {JSON.stringify(f1ShipmentViewData) !== '{}' &&
                            f1ShipmentViewData.toBeShipped &&
                            f1ShipmentViewData.toBeShipped !== '{}'
                                ? this.showShipmentStatau(
                                      'toBeShipped',
                                      f1ShipmentViewData.toBeShipped,
                                      0,
                                      f1ShipmentViewData.status,
                                  )
                                : null}
                        </ul>
                        <ul className="f1-received-view-container">
                            {JSON.stringify(f1ShipmentViewData) !== '{}' &&
                                f1ShipmentViewData.received &&
                                f1ShipmentViewData.received.length > 0 &&
                                f1ShipmentViewData.received.map(
                                    (receivedItem, receivedIndex) =>
                                        this.showShipmentStatau(
                                            'received',
                                            receivedItem,
                                            receivedIndex,
                                            f1ShipmentViewData.status,
                                        ),
                                )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        f1ShipmentViewData: host.f1ShipmentViewData,
    };
};

const mapDispatchToProps = {
    getF1ShipmentViewData,
    refreshF1OrderList,
    setF1OrderSource,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(F1OrderReceiveManagement);
